// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 745 ? "posthog" : chunkId) + "." + {"230":"8048c6d9","478":"6f42ba9f","745":"cbb896ac"}[chunkId] + ".chunk.js";
};